module.exports = __webpack_public_path__ + "static/media/background-11.4c318f98.jpg";